// extracted by mini-css-extract-plugin
module.exports = {"label_wrapper":"dd31006766--label_wrapper--2UPtC","label":"dd31006766--label--1FJgm","discount":"dd31006766--discount--8atTj"};